import React, { FC } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { TestID } from '../../../../utils/PropTypesDefinitions'

const SummaryDropupButton: FC<TestID> = ({ testID }) => (
    <Grid
        testID={testID}
        noExpand
        width={20}
        height={20}
        borderRadius={10}
        backgroundColor="onyx-5"
        center
    >
        <FontelloIcon name="scroll-top" color="pearl" fontSize={8} />
    </Grid>
)

export default SummaryDropupButton
